/**
 * 获取该用户已经配置的权限
 */
export function getUserAuthorityTree() {
  return Promise.resolve([])
}
